<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
    <span>
        <a class="metadata-text" href="{{link.href}}" rel="noopener noreferrer" target="_blank">
            <i class="mr-2 fa-xl" [ngClass]="iconStyle"></i>
            {{ link.text }}
        </a>
    </span>
</div>
